import React from 'react';

import logo from '../../assets/img/logo.png'
import Social from '../Social/Social';

const Footer = () => {
    return (
        <footer className="footer">
            <div className="footer__container">
                <figure className="footer__logo-box">
                    <img src={logo} alt= "FooterLogo" className = "footer__logo"/>
                </figure>
                <p className="paragraph footer__paragraph" data-aos = "fade-up"><span>Thanks for scrolling,</span> see you later!</p>
                <Social className = "footer__social" data-aos = "fade-up"/>
            </div>
        </footer>
    );
};

export default Footer;